export enum EUserRole {
  MEMBER = 'MEMBER',
  PRACTICE_ADMIN = 'PRACTICE_ADMIN',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  COMMUNITY_ADMIN = 'COMMUNITY_ADMIN',
  PRACTICE_CLINICIAN = 'PRACTICE_CLINICIAN',
  PATIENT = 'PATIENT',
  PATIENT_CONTACT = 'PATIENT_CONTACT',
  COMMUNITY_RESIDENT_MANAGEMENT = 'COMMUNITY_RESIDENT_MANAGEMENT',
}
